(function () {
  if (window.__simplerBlogFeaturedPanelBound) return;
  window.__simplerBlogFeaturedPanelBound = true;

  function showToast(lightbox, message) {
    var toast = lightbox.querySelector('[data-sbfp-lightbox-toast]');
    if (!toast) return;

    toast.textContent = message;
    toast.classList.add('is-visible');

    clearTimeout(toast._hideTimer);
    toast._hideTimer = setTimeout(function () {
      toast.classList.remove('is-visible');
    }, 2200);
  }

  function portalLightbox(lightbox) {
    if (lightbox.parentElement !== document.body) {
      document.body.appendChild(lightbox);
    }
  }

  function mountLightbox(sectionRoot) {
    var lightbox = sectionRoot.querySelector('[data-sbfp-lightbox]');
    if (!lightbox || lightbox.dataset.sbfpBound === 'true') return;

    var thumbs = Array.prototype.slice.call(
      sectionRoot.querySelectorAll('[data-sbfp-gallery-thumb]')
    );
    if (thumbs.length === 0) return;

    portalLightbox(lightbox);

    var images = thumbs.map(function (thumb) {
      return {
        src: thumb.getAttribute('data-sbfp-gallery-src') || '',
        alt: thumb.getAttribute('data-sbfp-gallery-alt') || '',
      };
    });

    var currentIndex = 0;
    var imageEl = lightbox.querySelector('[data-sbfp-lightbox-image]');
    var counterEl = lightbox.querySelector('[data-sbfp-lightbox-counter]');
    var prevBtn = lightbox.querySelector('[data-sbfp-lightbox-prev]');
    var nextBtn = lightbox.querySelector('[data-sbfp-lightbox-next]');
    var closeBtn = lightbox.querySelector('[data-sbfp-lightbox-close]');
    var zoomBtn = lightbox.querySelector('[data-sbfp-lightbox-zoom]');
    var fullscreenBtn = lightbox.querySelector('[data-sbfp-lightbox-fullscreen]');
    var shareBtn = lightbox.querySelector('[data-sbfp-lightbox-share]');

    function renderSlide() {
      var current = images[currentIndex];
      if (!current || !imageEl) return;

      imageEl.src = current.src;
      imageEl.alt = current.alt;

      if (counterEl) {
        counterEl.textContent = currentIndex + 1 + ' / ' + images.length;
      }

      if (prevBtn) {
        prevBtn.disabled = currentIndex === 0;
      }

      if (nextBtn) {
        nextBtn.disabled = currentIndex === images.length - 1;
      }
    }

    function openLightbox(index) {
      currentIndex = index;
      lightbox.classList.remove('is-zoomed', 'is-fullscreen');
      renderSlide();
      portalLightbox(lightbox);
      lightbox.classList.add('is-open');
      lightbox.setAttribute('aria-hidden', 'false');
      document.body.classList.add('sbfp-lightbox-open');

      if (closeBtn) {
        closeBtn.focus();
      }
    }

    function closeLightbox() {
      if (document.fullscreenElement === lightbox) {
        document.exitFullscreen().catch(function () {});
      }

      lightbox.classList.remove('is-open', 'is-zoomed', 'is-fullscreen');
      lightbox.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('sbfp-lightbox-open');
    }

    function goTo(offset) {
      var nextIndex = currentIndex + offset;
      if (nextIndex < 0 || nextIndex >= images.length) return;
      currentIndex = nextIndex;
      lightbox.classList.remove('is-zoomed');
      renderSlide();
    }

    thumbs.forEach(function (thumb, index) {
      thumb.addEventListener('click', function () {
        openLightbox(index);
      });
    });

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        goTo(-1);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        goTo(1);
      });
    }

    if (closeBtn) {
      closeBtn.addEventListener('click', closeLightbox);
    }

    if (zoomBtn) {
      zoomBtn.addEventListener('click', function () {
        lightbox.classList.toggle('is-zoomed');
      });
    }

    if (fullscreenBtn) {
      fullscreenBtn.addEventListener('click', function () {
        if (document.fullscreenElement === lightbox) {
          document.exitFullscreen().catch(function () {});
          lightbox.classList.remove('is-fullscreen');
          return;
        }

        lightbox.requestFullscreen().then(function () {
          lightbox.classList.add('is-fullscreen');
        }).catch(function () {});
      });
    }

    document.addEventListener('fullscreenchange', function () {
      if (document.fullscreenElement !== lightbox) {
        lightbox.classList.remove('is-fullscreen');
      }
    });

    if (shareBtn) {
      shareBtn.addEventListener('click', function () {
        var current = images[currentIndex];
        if (!current || !current.src) return;

        if (navigator.share) {
          navigator.share({
            title: current.alt || 'Gallery image',
            url: current.src,
          }).catch(function () {});
          return;
        }

        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(current.src).then(function () {
            showToast(lightbox, 'Image link copied');
          }).catch(function () {
            showToast(lightbox, 'Unable to share image');
          });
          return;
        }

        showToast(lightbox, 'Sharing is not supported');
      });
    }

    lightbox.addEventListener('click', function (event) {
      if (event.target === lightbox) {
        closeLightbox();
      }
    });

    document.addEventListener('keydown', function (event) {
      if (!lightbox.classList.contains('is-open')) return;

      if (event.key === 'Escape') {
        closeLightbox();
      } else if (event.key === 'ArrowLeft') {
        goTo(-1);
      } else if (event.key === 'ArrowRight') {
        goTo(1);
      }
    });

    lightbox.dataset.sbfpBound = 'true';
  }

  function mountSection(sectionRoot) {
    mountLightbox(sectionRoot);
  }

  function boot(root) {
    (root || document).querySelectorAll('.simpler-blog-featured-panel').forEach(mountSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot(document);
    });
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = document.getElementById('shopify-section-' + event.detail.sectionId);
    if (!root) return;
    boot(root);
  });
})();
